module.exports = __webpack_public_path__ + "img/bar_blue.8eaea4c8.svg";